import {
  NotificationsActive as UnMutedIcon,
  NotificationsOff as MutedIcon,
} from '@mui/icons-material'
import { Button, Tooltip } from '@mui/material'

import { DateTime } from 'luxon'

/**
 * @component
 * @param {Object} props - The props for the component.
 * @param {Object} props.params
 * @param {Object} props.params.row
 * @param {Function} props.params.setMuteContext
 */
export default function EventListMuteButton({ row, setMuteContext }) {
  const isUnitMuted = (event) => {
    const now = DateTime.now()
    if (event.unitMuteNotificationsStart) {
      const muteStart = DateTime.fromISO(event.unitMuteNotificationsStart)
      if (event.unitMuteNotificationsEnd) {
        const muteEnd = DateTime.fromISO(event.unitMuteNotificationsEnd)
        return muteStart < now < muteEnd
      }
      return now > muteStart
    }
    return false
  }

  const buttonProps = {
    fullWidth: true,
    variant: 'outlined',
    size: 'small',
  }

  if (row.unit && isUnitMuted(row)) {
    return (
      <Tooltip title="Unmute this unit">
        <Button
          {...buttonProps}
          startIcon={<MutedIcon />}
          color="error"
          onClick={() =>
            setMuteContext({ unitName: row.unitName, unit: row.unit, isMute: false })
          }
        >
          Unmute
        </Button>
      </Tooltip>
    )
  }
  return (
    <Tooltip title="Mute all notifications for this unit for 24 hours">
      <Button
        {...buttonProps}
        startIcon={<UnMutedIcon />}
        color="secondary"
        onClick={() =>
          setMuteContext({ unitName: row.unitName, unit: row.unit, isMute: true })
        }
      >
        Mute
      </Button>
    </Tooltip>
  )
}
